import React, { Component } from "react";
import { withCars } from "../../../../shared/containers/containerCars";
import { withFilterCars } from "../../../../shared/containers/containerFilterCars";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import Notification from "../../../../shared/items/static/notification";
import styles from "./winterUnitsBar.module.scss";
import WinterUnitsListItems from "./WinterUnitsListItems";
import { withWinter } from "../../../../shared/containers/containerWinter";
import { unitFilterService } from "../../../sections/cars/unitFilterService";
import { withAuth } from "../../../../shared/containers/containerAuth";

class WinterUnitsList extends Component {
  componentDidMount() {
    const { onGetWinterUnits } = this.props;
    unitFilterService.didMount(this.props);

    onGetWinterUnits();
  }

  componentDidUpdate(prevProps) {
    unitFilterService.didUpdate(prevProps, this.props);
  }

  render() {
    const { handleScrollTo, listUnits, dataStateUnits, winterUnitsDataState, winterUnits } = this.props;

    if (dataStateUnits === states.REQUEST || winterUnitsDataState === states.REQUEST) {
      return (
        <React.Fragment>
          <div className={styles.winterUnitsList_wrapper}>
            <div className={styles.container_preloader}>
              <Preloader />
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (listUnits.length === 0) {
      return (
        <React.Fragment>
          <div className={styles.winterUnitsList_wrapper}>
            <Notification type="warning">
              <p>По данным параметрам поиска автомобили не найдены.</p>
            </Notification>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.winterUnitsList_wrapper}>
          <div className={styles.winterUnitsList}>
            <WinterUnitsListItems data={listUnits} handleScrollTo={handleScrollTo} winterUnits={winterUnits} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withAuth(withWinter(withCars(withFilterCars(WinterUnitsList))));
